import { AbstractService } from '@uniqoders/sdk';

export default class AdminDashboardService extends AbstractService {
  /**
   * Retrieves admin dashboard KPI, upcoming cases, and yearly/monthly statistics.
   */
  public getDashboardData(filters: { year?: number }): Promise<any> {
    return this.request({
      method: 'get',
      url: this.buildPath('/admin/dashboard'),
      params: filters as any,
    });
  }
}
